import React from 'react'
import { Form, FormGroup, ControlLabel, FormControl, Button, ButtonToolbar } from 'react-bootstrap'

export default class Version extends React.Component {

  constructor(props, context) {
    super(props, context)

    this.handleChange = this.handleChange.bind(this)
    this.handlePost = this.handlePost.bind(this)

    this.state = {
      organization: this.props.organization
    }
  }

  handleChange(e) {
    const key = e.target.id
    const organization = this.state.organization
    organization[key] = e.target.value
    this.setState({ organization: organization })
  }

  handlePost() {
    this.props.updateCallback(this.state.organization)
  }

  handleCancel() {

  }

  validate() {
    const { organization } = this.state
    const isEmailValid = true;
    return (isEmailValid && organization.version && organization.versionActiveFrom)
  }

  render() {
    const { organization } = this.state

    return (
      <div>
        <Form onSubmit={e => e.preventDefault()}>
          <FormGroup controlId="version">
            <ControlLabel>Versie *</ControlLabel>
            <FormControl onChange={this.handleChange} type="text" value={organization.version} />
          </FormGroup>
          <FormGroup controlId="versionActiveFrom">
            <ControlLabel>Versie is actief vanaf *</ControlLabel>
            <FormControl onChange={this.handleChange} type="text" value={organization.versionActiveFrom} />
          </FormGroup>
        </Form>

        <div className="table-actions">
          <ButtonToolbar>
            <Button onClick={this.handleCancel}>Annuleren</Button>
            <Button bsStyle="primary" disabled={!this.validate()} onClick={() => this.handlePost()}>Opslaan</Button>
          </ButtonToolbar>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/Account/components/Version.js